'use strict';

const isBot = () => {
    const userAgent = (navigator.userAgent || navigator.vendor || window.opera);
    const regexAgent = new RegExp(CustomPreferences.BOT_USER_AGENT_REGEX, 'i');
    return regexAgent.test(userAgent);
};

module.exports = isBot;
